import React from "react";
import { ShimmerText } from "./ShimmerText";
import cashboardIcon from "../assets/cashboard-icon.svg";

export function AuthLoadingScreen() {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-bg2 px-6 py-12">
      <div className="max-w-sm text-center">
        <img src={cashboardIcon} alt="Cashboard" className="w-16 h-16 mx-auto mb-6" />
        <ShimmerText text="Connecting to Cashboard..." className="text-[15px]" />
      </div>
    </div>
  );
}
